import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShowTdl = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 9,
	viewBox: "0 0 21 9",
	...props,
	children: /* @__PURE__ */ _jsxs("text", {
		fill: "#4A5666",
		fillRule: "evenodd",
		fontFamily: "Lato-Regular, Lato",
		fontSize: 12,
		letterSpacing: -.5,
		transform: "translate(0 -3)",
		children: [/* @__PURE__ */ _jsx("tspan", {
			x: 0,
			y: 12,
			children: "TD"
		}), /* @__PURE__ */ _jsx("tspan", {
			x: 15.116,
			y: 12,
			children: "L"
		})]
	})
});
export default SvgShowTdl;
